import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../redux/network/https";
import { endPoints, queryKeys } from "../../redux/network/constant";

 

// ============ FETCH GROUP MEMBERS ============
const fetchGroupMembers = async ({ queryKey }) => {
  // queryKey structure: ["chat", "group-members", channelId]
  const channelId = queryKey[2];
  
  const { data } = await axiosInstance.get(endPoints.GroupMembers(channelId));
  const members = data?.data?.members || [];
  return members;
};

export const useGroupMembers = (channelId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.GroupMembers(channelId),
    queryFn: fetchGroupMembers,
    enabled: !!channelId,
    staleTime: 30 * 1000, // 30 seconds
    refetchOnWindowFocus: false,
    ...options,
  });
};

// ============ FETCH AVAILABLE USERS ============
const fetchAvailableUsers = async ({ queryKey }) => {
  // queryKey structure: ["chat", "available-users", channelId]
  const channelId = queryKey[2];
  
  const { data } = await axiosInstance.get(endPoints.GroupAvailableUsers(channelId));
  const users = data?.data?.users || [];
  return users;
};

export const useAvailableUsers = (channelId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.GroupAvailableUsers(channelId),
    queryFn: fetchAvailableUsers,
    enabled: !!channelId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
};

// ============ ADD GROUP MEMBERS ============
const addGroupMembers = async ({ channelId, user_ids }) => {
  const { data } = await axiosInstance.post(
    endPoints.GroupAddMembers(channelId),
    { user_ids }
  );
  return data?.data;
};

export const useAddGroupMembers = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: addGroupMembers,
    onSuccess: (data, { channelId }) => {
      // Invalidate members list
      queryClient.invalidateQueries({
        queryKey: queryKeys.GroupMembers(channelId),
      });
      
      // Invalidate available users list
      queryClient.invalidateQueries({
        queryKey: queryKeys.GroupAvailableUsers(channelId),
      });
    },
  });
};

// ============ REMOVE GROUP MEMBER ============
const removeGroupMember = async ({ channelId, user_id }) => {
  const { data } = await axiosInstance.post(
    endPoints.GroupRemoveMember(channelId),
    { user_id }
  );
  return data?.data;
};

export const useRemoveGroupMember = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: removeGroupMember,
    onSuccess: (data, { channelId }) => {
      // Invalidate members list
      queryClient.invalidateQueries({
        queryKey: queryKeys.GroupMembers(channelId),
      });
      
      // Invalidate available users list
      queryClient.invalidateQueries({
        queryKey: queryKeys.GroupAvailableUsers(channelId),
      });
    },
  });
};
